import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";

const Hero = () => {
  return (
    <section className="relative min-h-screen flex items-center overflow-hidden">
      {/* Background */}
      <div className="absolute inset-0 z-0">
        <div className="absolute inset-0 bg-gradient-to-br from-white/90 via-white/80 to-medical-50/70"></div>
        <div 
          className="absolute inset-0 bg-cover bg-center"
          style={{ 
            backgroundImage: "url('https://images.unsplash.com/photo-1581094794329-c8112a89af12?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2070&q=80')",
            backgroundPosition: "center",
            zIndex: -1
          }}
        ></div>
      </div>

      {/* Content */}
      <div className="container mx-auto px-6 md:px-8 relative z-10 pt-20">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div className="order-2 lg:order-1 space-y-6 md:space-y-8">
            <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-gray-900 opacity-0 animate-fade-in">
              Estetska in Rekonstruktivna Kirurgija
            </h1>
            <p className="text-lg md:text-xl text-gray-700 max-w-xl opacity-0 animate-fade-in animate-delay-100">
              Specialistična klinika s poudarkom na vrhunskih estetskih in rekonstruktivnih posegih, individualiziranih za vaše potrebe, pod vodstvom dr. Danijela Novaka.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 pt-2 pb-4 opacity-0 animate-fade-in animate-delay-200">
              <Button asChild className="bg-medical-500 hover:bg-medical-600 text-white rounded-full px-8 py-6 text-lg font-medium btn-hover-effect">
                <Link to="/kontakt">Rezerviraj posvet</Link>
              </Button>
              <Button asChild variant="outline" className="border-medical-300 text-medical-700 hover:bg-medical-50 rounded-full px-8 py-6 text-lg font-medium">
                <Link to="/storitve">Naše storitve</Link>
              </Button>
            </div>
          </div>
          <div className="order-1 lg:order-2 opacity-0 animate-fade-in lg:animate-slide-in-right">
            <div className="glass-card p-6 md:p-8 lg:p-10 max-w-md mx-auto lg:ml-auto">
              <h3 className="text-xl md:text-2xl font-bold text-gray-900 mb-4">
                Dr. Danijel Novak
              </h3>
              <p className="text-gray-700 mb-6">
                Specialist plastične, rekonstruktivne in estetske kirurgije z več kot 15 let izkušenj in strastjo do detajlov.
              </p>
              <div className="flex justify-between items-center">
                <div className="space-y-1">
                  <p className="text-gray-900 font-medium">Ljubljana in Celje</p>
                  <p className="text-medical-600">Naročite se še danes</p>
                </div>
                <Button asChild variant="outline" className="border-medical-300 text-medical-700 hover:bg-medical-50 rounded-full">
                  <Link to="/o-nas">Več o nas</Link>
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;